import { render, staticRenderFns } from "./EN.vue?vue&type=template&id=60c1333c&scoped=true&"
import script from "./EN.vue?vue&type=script&lang=js&"
export * from "./EN.vue?vue&type=script&lang=js&"
import style0 from "./EN.vue?vue&type=style&index=0&id=60c1333c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c1333c",
  null
  
)

export default component.exports